import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import Aux from '../../hoc/Aux';

const customer = (props) => {

  let companyInputs = null;
  if(props.data.data.isCompany){
    companyInputs = (
      <Aux>
        <Row>
          <Col xs={12} md={6} className="mb-2 mb-md-0">
            <Form.Control 
              className={
                props.data.data.company.name.isValid!==null ?
                  props.data.data.company.name.isValid===true? "is-valid" : "is-invalid"
                : null
              }
              name="org-name" placeholder="Ettevõtte nimi *" 
              value={props.data.data.company.name.value??""} 
              onChange={(e) => props.companyFieldChanged("name", e)} />
          </Col>
          <Col xs={12} md={6} className="mb-2 mb-md-0">
            <Form.Control 
              className={
                props.data.data.company.regNo.isValid!==null ?
                  props.data.data.company.regNo.isValid===true? "is-valid" : "is-invalid"
                : null
              }
              name="org-reg-no" placeholder="Ettevõtte reg. nr *" 
              value={props.data.data.company.regNo.value??""} 
              onChange={(e) => props.companyFieldChanged("regNo", e)} />
          </Col>
        </Row>
        <Row className="mt-2">
          <Col xs={12} md={6} className="mb-2 mb-md-0">
            <Form.Control 
              className={
                props.data.data.company.address.isValid!==null ?
                  props.data.data.company.address.isValid===true? "is-valid" : "is-invalid"
                : null
              }
              name="org-address" placeholder="Ettevõtte aadress *" 
              value={props.data.data.company.address.value??""} 
              onChange={(e) => props.companyFieldChanged("address", e)}  />
          </Col>
        </Row>
      </Aux>
    );

  } 

  return (
    <Row className="justify-content-md-center">
      <Col xs={12}>
        <Form>
          <Form.Group>
            <Form.Label><i className="fa fa-address-card-o"></i> Sisestage enda kontaktandmed</Form.Label>
          

          <Row>
            <Col xs={12} md={6} className="mb-2 mb-md-0">
              <Form.Control 
                className={
                  props.data.data.nameFirst.isValid!==null ?
                    props.data.data.nameFirst.isValid===true? "is-valid" : "is-invalid"
                  : null
                }
                name="first-name" placeholder="Eesnimi *" 
                value={props.data.data.nameFirst.value??""} 
                onChange={(e) => props.customerFieldChanged("nameFirst", e)} />

            </Col>
            <Col xs={12} md={6} className="mb-2 mb-md-0">
              <Form.Control 
                className={
                  props.data.data.nameLast.isValid!==null ?
                    props.data.data.nameLast.isValid===true? "is-valid" : "is-invalid"
                  : null
                }
                name="last-name" placeholder="Perenimi *" 
                value={props.data.data.nameLast.value??""} 
                onChange={(e) => props.customerFieldChanged("nameLast", e)}  />

            </Col>
          </Row>
          <Row className="mt-2">
            <Col xs={12} md={6} className="mb-2 mb-md-0">
              <Form.Control 
                className={
                  props.data.data.email.isValid!==null ?
                    props.data.data.email.isValid===true? "is-valid" : "is-invalid"
                  : null
                }
                name="email" placeholder="E-mail *" 
                value={props.data.data.email.value??""} 
                onChange={(e) => props.customerFieldChanged("email", e)} />

            </Col>
            <Col xs={12} md={6} className="mb-2 mb-md-0">
              <Form.Control 
                className={
                  props.data.data.phone.isValid!==null ?
                    props.data.data.phone.isValid===true? "is-valid" : "is-invalid"
                  : null
                }
                name="phone" placeholder="Telefoni nr *" 
                value={props.data.data.phone.value??""} 
                onChange={(e) => props.customerFieldChanged("phone", e)} />

            </Col>
          </Row>
          <Row className="mt-2">
            <Col xs={12} md={6} className="mb-2 mb-md-0">
              <Form.Group controlId="formBasicCheckbox">
                <Form.Check type="checkbox" label="Ettevõte?" value="1" defaultChecked={props.data.data.isCompany? true:false} onChange={(e) => props.customerFieldChanged("isCompany", e)} />
              </Form.Group>
            </Col>
          </Row>

          {companyInputs}

          </Form.Group>

        </Form>
      </Col>
    </Row>
  );
};

export default customer;